import { render, staticRenderFns } from "./PostPaidPage.vue?vue&type=template&id=11e562fc&"
import script from "./PostPaidPage.vue?vue&type=script&lang=js&"
export * from "./PostPaidPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports